import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

export class DevMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    if (environment.production) {
      // In production, never render raw translation key paths.
      return '';
    }

    // eslint-disable-next-line no-console
    console.warn('[i18n] Missing translation key:', params.key);
    return params.key;
  }
}

